module.exports = __webpack_public_path__ + "static/media/Progress2.2d0f6f05.png";